import React from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "redux-form";

import { CustomInput } from "components";
import RadioButton from "components/radioButton";
import { trimMidSentenceNormalizer, trimNormalizer } from "validators";
import {
	normalizeAll,
	onlyAlphanumericAndSpecialCharacters,
	validateWhenRefundPolicyIsOther,
} from "validators/validation";

import styles from "./businessInfo.module.scss";

const RefundPolicy = ({ formValues }) => {
	return (
		<>
			<div className={styles.addressTitle}>Refund Policy</div>
			<Row className="pb-3">
				<Col lg={3}>
					<Field
						component={RadioButton}
						value="RefundWithin30Days"
						className={styles.radioButton}
						name="refundPolicy"
						type="radio"
						label="Refund Within 30 Days"
						id="sameRefund"
					/>
				</Col>
				<Col lg={3}>
					<Field
						component={RadioButton}
						value="ExchangeOnly"
						className={styles.radioButton}
						name="refundPolicy"
						type="radio"
						label="Exchange Only"
						id="sameExchange"
					/>
				</Col>
				<Col lg={3}>
					<div className={styles.wrappRadioInput}>
						<Field
							component={RadioButton}
							value="Other"
							className={`${styles.radioButton} ${styles.mr25}`}
							name="refundPolicy"
							type="radio"
							label="Other"
							id="sameOther"
							requiredMark={formValues?.refundPolicy === "Other"}
						/>
						<Field
							component={CustomInput}
							type="text"
							disabled={formValues?.refundPolicy !== "Other"}
							validate={validateWhenRefundPolicyIsOther}
							name="refundPolicyIfOther"
							normalizeOnBlur={trimNormalizer}
							normalize={normalizeAll([
								onlyAlphanumericAndSpecialCharacters,
								trimMidSentenceNormalizer,
							])}
							smSelect={12}
						/>
					</div>
				</Col>
				<Col lg={3} style={{ paddingLeft: "6%" }}>
					<Field
						component={RadioButton}
						value="None"
						className={styles.radioButton}
						name="refundPolicy"
						label="None"
						type="radio"
						id="sameNone"
					/>
				</Col>
			</Row>
		</>
	);
};

export default RefundPolicy;
